<template>
    <transition name="fade">

        <div class="login-row">
            <div class="login justify-content-center">
                <div>
                    <div class="row col justify-content-center">
                        <a class="valign" href="#">
                            <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
                        </a>
                    </div>

                    <div class="row justify-content-center" style="padding: 40px">
                        <h2 class="title-principal">Recuperar Senha</h2>
                    </div>

                    <div class="row justify-content-center">
                            <div class="col-md-10">
                                <div class="form-group">
                                    <v-label label="E-mail"></v-label>
                                    <input ref="email" type="text" class="form-control" v-model="email" @keydown.enter="handleEnviar" placeholder="exemplo@exemplo.com.br">
                                </div>
                            </div>
                            <div class="col-md-10 mb-2">
                                <button type="button" class="login-button" style="width: 100%" @click="handleEnviar"> Recuperar Senha </button>
                            </div>
                            <div class="col-md-10 text-center mt-2">
                                <a href="javascript:void(0);" @click="handleVoltar">
                                    Voltar
                                </a>
                            </div>
                            <div class="col-md-10 mt-3">
                                <alert v-if="errmessages" type="warning" :close="false" title="Erro" :messages="errmessages"></alert>
                            </div>
                    </div>
                </div>
            </div>
            <div class="login-side-column">
                <div class="login-side-container login-side-container-bg-blue" >
                    <img class="login-side" src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/login.png" alt="Aplicativo de">
                </div>
                <!-- <div class="login-side" style="background-image: url(https://static.wixstatic.com/media/454959_39f929b7cbca40cbb7ec07c657953697~mv2.jpg);"> -->
                <!-- <img src="https://static.wixstatic.com/media/454959_ecc66f515bfb493db85afea3b3418ecf~mv2.jpg" style="object-fit: cover;"> -->
                <!-- <img src="https://static.wixstatic.com/media/454959_39f929b7cbca40cbb7ec07c657953697~mv2.jpg" style="object-fit: cover;"> -->
                </div>
            </div>

        </div>

        <!-- <div class="login-row">
            <div class="login justify-content-center">
                <div>
                    <div class="row col justify-content-center">
                        <a class="valign" href="#">
                            <img src="logo-nb.png">
                        </a>
                    </div>

                    <div class="row justify-content-center" style="padding: 40px">
                        <h2 class="title-principal">Recuperar Senha</h2>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-md-10 col-10">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <v-label label="E-mail"></v-label>
                                        <input ref="email" type="text" class="form-control" v-model="email" @keydown.enter="handleEnter('email')" placeholder="exemplo@exemplo.com.br">
                                    </div>
                                </div>
                            </div>
                            <div class="w-100">
                                <button type="button" class="login-button" style="width: 100%" @click="handleEnviar"> Recuperar Senha </button>
                            </div>
                            <div class="row col justify-content-center mt-2">
                                <a href="javascript:void(0);" @click="handleVoltar">
                                    Voltar
                                </a>
                            </div>
                            <div class="w-100 mt-5">
                                <alert v-if="errmessages" type="warning" :close="false" title="Erro" :text="errmessages"></alert>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="login-side-column">
                <div class="login-side" style="background-image: url(https://static.wixstatic.com/media/454959_39f929b7cbca40cbb7ec07c657953697~mv2.jpg);">
                </div>
            </div>

        </div> -->



    </transition>

</template>

<script>

import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
    props: {
    },

    data() {
        return {
            email: null,
            errmessages: null, 
            btEnviar: 'Enviar'
        }
    },

    computed: {
    },

    methods: {
        handleEnviar () {
            //BOTAO ENVIAR
            this.apiPost()
        },

        handleVoltar () {
            this.$router.push('login')
        },

        handleCadastrar () {
            this.$router.push('registro')
        },

        async apiPost () {
            
            //efetua o login em ords/nbapp/login/
            var sendData = { email: this.email }
            this.btEnviar = 'Enviando a senha...'
            this.errmessages = null

            const login = await apiORDSapp(this, 'recuperar/', 'post', sendData)
            this.btEnviar = 'Enviar'

            if (login.errmessages) {
              this.errmessages = login.errmessages
              return
            }
            
            //login efetuado: recebe o token para autenticacao, urlapi, token app
            this.errmessages = null

            this.$router.push('login')

        },
    },

    components: {
    },

    created () {
        this.$scrollTo(0)
        this.email = ''
        this.$nextTick(function () {
            this.$refs.email.focus()
        })
    }

}

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/forms/app-recuperar-form.vue